"use client";

import Link from "next/link";
import { Icons } from "@/components/icons";
import { AnimatedSection, FloatingElement } from "./motion";

export function CTASection() {
  return (
    <AnimatedSection className="container py-16 md:py-24 lg:py-32">
      <div className="mx-auto max-w-3xl text-center">
        <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-indigo-600 via-violet-600 to-purple-700 p-10 shadow-2xl shadow-indigo-500/20 md:p-16">
          {/* Decorative dot pattern */}
          <div
            className="pointer-events-none absolute inset-0 opacity-10"
            style={{
              backgroundImage: "radial-gradient(circle, white 1px, transparent 1px)",
              backgroundSize: "24px 24px",
            }}
          />
          {/* Animated glow orbs */}
          <div className="pointer-events-none absolute -top-20 -left-20 h-60 w-60 rounded-full bg-indigo-400/20 blur-3xl animate-subtle-float" />
          <div className="pointer-events-none absolute -bottom-20 -right-20 h-60 w-60 rounded-full bg-purple-400/20 blur-3xl animate-subtle-float [animation-delay:4s]" />

          <div className="relative space-y-6">
            <FloatingElement distance={4} duration={6}>
              <h2 className="font-heading text-3xl font-bold tracking-tight text-white md:text-4xl">
                Ready to deploy AI everywhere?
              </h2>
            </FloatingElement>
            <p className="mx-auto max-w-md text-base leading-relaxed text-indigo-100">
              Join thousands of teams using BotByte AI to build chatbots, generate websites, and
              automate workflows.
            </p>
            <div className="flex flex-wrap items-center justify-center gap-4">
              <Link
                href="/login"
                prefetch
                className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-3 text-sm font-semibold text-indigo-700 shadow-lg transition-all hover:-translate-y-0.5 hover:shadow-xl"
              >
                <Icons.bot className="h-4 w-4" />
                Start Building — Free
              </Link>
              <Link
                href="/docs"
                prefetch
                className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/10 px-8 py-3 text-sm font-semibold text-white backdrop-blur-sm transition-all hover:bg-white/20"
              >
                <Icons.plug className="h-4 w-4" />
                Read the Docs
              </Link>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>
  );
}
